var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-container show" }, [
    _c("div", { staticClass: "panel-content" }, [
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-column align-items-center justify-content-center p-4",
        },
        [
          this.location.id > 0
            ? _c("h5", { staticClass: "mb-0 fw-700 text-center mt-3" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(this.location.title) +
                    "\n                "
                ),
              ])
            : _c("h5", { staticClass: "mb-0 fw-700 text-center mt-3" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.__t("NEW_REST")) +
                    "\n                "
                ),
              ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("div", { staticClass: "form-group mt-2" }, [
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "advanced_name" } },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.__t("REST_NAME")) +
                    "\n                    "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "input-group flex-nowrap" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.location.title,
                    expression: "location.title",
                  },
                ],
                staticClass: "form-control",
                attrs: { id: "advanced_name", type: "text" },
                domProps: { value: _vm.location.title },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.location, "title", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "panel-tag mt-2" }, [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.__t("UBER_LOCATION_PARAMS")) +
                "\n                "
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.general_fields, function (general_field) {
            return _c("div", { staticClass: "form-group mt-2" }, [
              _c("label", { staticClass: "form-label" }, [
                _vm._v(
                  "\n                        " +
                    _vm._s(general_field.title) +
                    "\n                    "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group flex-nowrap" }, [
                _vm._m(1, true),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.location.general_fields[general_field.key],
                      expression: "location.general_fields[general_field.key]",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    disabled: general_field.key == "store_id",
                    id: general_field.key,
                    type: "text",
                  },
                  domProps: {
                    value: _vm.location.general_fields[general_field.key],
                  },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.location.general_fields,
                        general_field.key,
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group mt-2" },
                [
                  _c("b-overlay", { attrs: { show: _vm.is_load_ext } }, [
                    _c(
                      "label",
                      {
                        staticClass: "form-label",
                        attrs: { for: "ext_rests" },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.__t("UBER_REST")) +
                            "*\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.ext_restaurants.length > 0
                      ? _c(
                          "div",
                          {},
                          [
                            _c(
                              "v-select",
                              {
                                staticClass: "imc_reasons",
                                attrs: {
                                  label: "name",
                                  reduce: function (rest) {
                                    return rest.store_id
                                  },
                                  options: _vm.ext_restaurants,
                                  filterable: false,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "option",
                                      fn: function (option) {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "d-center" },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(option.name) +
                                                    "\n                                        "
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("div", [
                                                _c("small", [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(option.store_id) +
                                                      "\n                                            "
                                                  ),
                                                ]),
                                              ]),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                                model: {
                                  value: _vm.general_uber_store_id,
                                  callback: function ($$v) {
                                    _vm.general_uber_store_id = $$v
                                  },
                                  expression: "general_uber_store_id",
                                },
                              },
                              [
                                _c("template", { slot: "no-options" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(_vm.__t("CHOICE_REST")) +
                                      "\n                                "
                                  ),
                                ]),
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ])
          }),
          _vm._v(" "),
          _c("location_general_params", { attrs: { location: _vm.location } }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }